export default "__VITE_ASSET__5bfb3dcd__"